import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import apiV2 from '../../service/apiV2.service'
import queryClient from '../../queryClient'
import { ServiceSend } from '../../types/interface/fsm.interface'
import { Events } from '../../FSM/shared/constants'

const usePaymentCallback = (send: ServiceSend) => {
  const location = useLocation()
  const [, paymentStatus] = location.pathname.split('/').filter(Boolean)
  const searchParams = new URLSearchParams(location.search)
  const policyNumber = parseInt(searchParams.get('policyNumber') ?? '', 10)
  const isMyPagesPaymentCallback = searchParams.get('flow') === 'mypages'

  useEffect(() => {
    const NON_SUCCESS_EVENTS: Partial<Record<string, Events>> = {
      error: Events.PAYMENT_ERROR,
      failure: Events.PAYMENT_FAILURE,
      cancel: Events.PAYMENT_CANCEL,
    }

    const handle = async () => {
      try {
        const nonSuccessEvent = NON_SUCCESS_EVENTS[paymentStatus]
        if (nonSuccessEvent) {
          send({ type: nonSuccessEvent })
          return
        }
        // success
        if (policyNumber) {
          await apiV2.updatePolicyPaymentOnSuccess(policyNumber)
          await queryClient.invalidateQueries({ queryKey: ['policies'] })
          if (isMyPagesPaymentCallback) {
            await queryClient.fetchQuery({
              queryKey: ['policies'],
              queryFn: () => apiV2.getAllPolicies(),
            })
          }
        }
        send({ type: Events.PAYMENT_SUCCESS })
      } catch {
        // Backend sends a Slack alert; treat API failure as a payment error.
        send({ type: Events.PAYMENT_ERROR })
      }
    }
    handle()
  }, [isMyPagesPaymentCallback, paymentStatus, policyNumber, send])
}

export default usePaymentCallback
